import { useToast as useShadcnToast } from "@/components/ui/use-toast";

export const useToast = useShadcnToast;